import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { AnimatedNumber } from "./AnimatedNumber";
import { IconBubble } from "./IconBubble";
import { Tile, type Domain } from "./Tile";

interface GlanceCardProps {
  label: string;
  value: number;
  unit?: string;
  precision?: number;
  icon: ReactNode;
  domain?: Domain;
  /** Optional secondary line, e.g. "+12% vs yesterday". */
  hint?: string;
  className?: string;
}

/** Top-row stat card: power now, lights on, inside temp, security state. */
export function GlanceCard({
  label,
  value,
  unit,
  precision = 0,
  icon,
  domain = "neutral",
  hint,
  className,
}: GlanceCardProps) {
  return (
    <Tile domain={domain} className={cn("min-w-36 flex-row items-center gap-3", className)}>
      <IconBubble domain={domain} size="md">
        {icon}
      </IconBubble>
      <div className="flex min-w-0 flex-col">
        <span className="truncate text-xs font-medium text-muted-foreground">{label}</span>
        <span className="text-xl font-semibold tabular-nums">
          <AnimatedNumber value={value} precision={precision} />
          {unit && <span className="ml-1 text-sm font-normal text-muted-foreground">{unit}</span>}
        </span>
        {hint && <span className="truncate text-xs text-muted-foreground">{hint}</span>}
      </div>
    </Tile>
  );
}
